import { render, staticRenderFns } from "./SelectUsers.vue?vue&type=template&id=6bf000f4"
import script from "./SelectUsers.vue?vue&type=script&lang=js"
export * from "./SelectUsers.vue?vue&type=script&lang=js"
import style0 from "./SelectUsers.vue?vue&type=style&index=0&id=6bf000f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports